import React from "react";
import "./footer.css";

/**  @module Components/Footer */

/**
 * Pie de página común a todas las pantallas del sistema.
 * @param {boolean} withSidebar - true cuando se muestra el menú lateral (el pie se alinea con el contenido)
 * @returns Un componente con el crédito de desarrollo.
 * @example
 * <Footer withSidebar={true}/>
 */

const Footer = ({ withSidebar = true }) => {
  return (
    <footer className={`footer footer-static footer-light app-footer${withSidebar ? "" : " app-footer-full"}`}>
      <p className="clearfix mb-0">
        <span className="d-block text-center">
          Experiencia digital creada por{" "}
          <a href="https://www.nxtara.com" target="_blank" rel="noopener noreferrer">Nxtara</a>
        </span>
      </p>
    </footer>
  );
};

export default Footer;
